import { putRequest } from 'utils/http'

export const changePassword = payload => {
  return putRequest(`/users/change-password`, payload)
}
